module.exports = __webpack_public_path__ + "img/logo.0e5172b1.png";